import * as React from "react"
import type { SVGProps } from "react"
const SvgTextSize = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M14 7.29h-3.5q-.63 0-1.06-.44A1.5 1.5 0 0 1 9 5.79q0-.63.44-1.07a1.5 1.5 0 0 1 1.06-.43h10q.63 0 1.06.43.45.45.44 1.07 0 .62-.44 1.06a1.5 1.5 0 0 1-1.06.44H17v11.5q0 .62-.44 1.06a1.5 1.5 0 0 1-1.06.44q-.63 0-1.06-.44a1.5 1.5 0 0 1-.44-1.06zm-9 5H3.5q-.63 0-1.06-.44A1.5 1.5 0 0 1 2 10.79q0-.62.44-1.07A1.5 1.5 0 0 1 3.5 9.3h6q.63 0 1.06.43.45.45.44 1.07 0 .62-.44 1.06a1.5 1.5 0 0 1-1.06.44H8v6.5q0 .62-.44 1.06a1.5 1.5 0 0 1-1.06.44q-.63 0-1.06-.44A1.5 1.5 0 0 1 5 18.79z" />
  </svg>
)
export default SvgTextSize
